import React from 'react';
import { Heart } from 'lucide-react';

// 疊在景點縮圖右上角的收藏按鈕（樣式跟 AttractionCard 的愛心一致，尺寸縮小配合行程頁小圖）
export function FavHeartButton({ name, cityKey, favorites, onToggleFav }) {
  if (!onToggleFav || !name) return null;
  const isFav = favorites?.includes(name);
  return (
    <button aria-label={isFav ? `移除${name}收藏` : `收藏${name}`}
      onClick={e => { e.stopPropagation(); onToggleFav(name, cityKey); }}
      style={{ position:'absolute', top:4, right:4, width:24, height:24, borderRadius:'50%', background:'rgba(255,255,255,0.92)', border:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', boxShadow:'0 1px 6px rgba(0,0,0,0.15)', padding:0, zIndex:2 }}>
      <Heart size={12} color={isFav ? '#ef4444' : '#94a3b8'} fill={isFav ? '#ef4444' : 'none'}/>
    </button>
  );
}
